import { createAiChatHttpClient } from './httpClient';
import { chatbotVisibilityByModuleId } from './paths';
import { getAiChatApiBase } from '../config';

/**
 * GET /chatbot/visibility/:moduleId — audience tokens (e.g. admin, internal, client).
 *
 * @param {string} moduleId
 * @returns {Promise<string[]>}
 */
export async function fetchChatbotModuleVisibility(moduleId) {
  if (!moduleId || !getAiChatApiBase()) {
    throw new Error('fetchChatbotModuleVisibility: missing moduleId or API base');
  }
  const client = createAiChatHttpClient();
  if (!client) {
    throw new Error('fetchChatbotModuleVisibility: no HTTP client');
  }
  const { data } = await client.get(chatbotVisibilityByModuleId(moduleId));
  if (!Array.isArray(data)) {
    throw new Error('Invalid chatbot visibility response');
  }
  return data.map((t) => String(t).trim()).filter(Boolean);
}
